import { Link } from "react-router-dom";
import { fetchReviewQueue } from "../lib/api";
import { useApi } from "../hooks/use-api";
import { useDocumentTitle } from "../hooks/use-document-title";

function severityBadge(severity: string): string {
  switch (severity) {
    case "critical":
      return "badge badge-error";
    case "warning":
      return "badge badge-warning";
    default:
      return "badge badge-info";
  }
}

export function ReviewQueuePage() {
  useDocumentTitle("Review Queue");
  const { data, loading, error, refetch } = useApi(fetchReviewQueue);

  return (
    <>
      <div className="card-header">
        <h1 className="page-title">Review Queue</h1>
        <button className="btn btn-sm" type="button" onClick={refetch}>
          Refresh
        </button>
      </div>

      {loading && <div className="loading">Loading review flags...</div>}
      {error && <div className="error-msg">{error}</div>}

      {data && data.length === 0 && (
        <div className="empty-state">No review flags</div>
      )}

      {data && data.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Severity</th>
              <th>Dealer</th>
              <th>Description</th>
              <th>Created</th>
              <th>Reviewed</th>
            </tr>
          </thead>
          <tbody>
            {data.map((flag) => (
              <tr key={flag.flagId}>
                <td className="mono">{flag.reviewType}</td>
                <td>
                  <span className={severityBadge(flag.severity)}>
                    {flag.severity}
                  </span>
                </td>
                <td>
                  {flag.dealerId ? (
                    <Link
                      to={`/dealer/${flag.dealerId}`}
                      className="dealer-link"
                    >
                      #{flag.dealerId}
                    </Link>
                  ) : (
                    "—"
                  )}
                </td>
                <td style={{ maxWidth: 300 }}>{flag.description}</td>
                <td className="mono">
                  {new Date(flag.createdAt).toLocaleString()}
                </td>
                <td className="mono">
                  {flag.reviewedAt
                    ? new Date(flag.reviewedAt).toLocaleString()
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
